
import { Carousel } from '@fancyapps/ui/dist/carousel/carousel.esm.js';

export function initSliders() {


    let sliderWork = document.querySelector('#work-slider .slider');
    let sliderJournal = document.querySelector('#journal-slider .slider');
    let sliderReport = document.querySelector('#report-slider .slider');


    if (sliderWork) {
        const workCarousel = new Carousel(
            sliderWork, {
                transition: 'slide',
                preload: 3, // Smoother navigation when using lazy loaded images
                Dots: true,
                Navigation: false,
                center: false
            },
        );
    }


    if (sliderJournal) {
        const journalCarousel = new Carousel(
            sliderJournal, {
                transition: 'slide',
                preload: 3, // Smoother navigation when using lazy loaded images
                Dots: true,
                Navigation: false,
                center: false
            },
        );

    }

    if (sliderReport) {
        const reportCarousel = new Carousel(
            sliderReport, {
                transition: 'slide',
                preload: 3, // Smoother navigation when using lazy loaded images
                Dots: true,
                Navigation: false,
                center: false,
                infinite: false
            },
        );

    }






}
